var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguseChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_795_735)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0016 25.6374C29.5004 25.6374 29.0941 26.0437 29.0941 26.5449V33.186C29.0941 33.6872 28.6878 34.0936 28.1866 34.0936H27.1829C26.6817 34.0936 26.2754 34.4999 26.2754 35.0011V37.4141C26.2754 37.9153 26.6817 38.3216 27.1829 38.3216H30.1229C30.2638 38.3216 30.4027 38.3544 30.5287 38.4174L34.1228 40.2144C34.7262 40.5161 35.4362 40.0773 35.4362 39.4027V39.2291C35.4362 38.7279 35.8425 38.3216 36.3437 38.3216H38.052C38.5533 38.3216 38.9596 37.9153 38.9596 37.414V26.5449C38.9596 26.0437 38.5533 25.6374 38.052 25.6374H30.0016ZM36.8455 35.0917C36.8455 35.4808 36.53 35.7963 36.1409 35.7963H33.3222C32.1564 35.7963 31.2081 34.8479 31.2081 33.6823C31.2081 32.9919 31.5409 32.3779 32.0544 31.992C32.3946 31.7364 32.6175 31.2891 32.6175 30.8636C32.6175 29.6979 33.5658 28.7496 34.7315 28.7496H35.4362C35.8254 28.7496 36.1409 29.0651 36.1409 29.4542C36.1409 29.8434 35.8254 30.1589 35.4362 30.1589H34.7315C34.3429 30.1589 34.0268 30.475 34.0268 30.8636C34.0268 31.2522 34.3429 31.5683 34.7315 31.5683H35.4362C35.8254 31.5683 36.1409 31.8838 36.1409 32.273C36.1409 32.6621 35.8258 32.9776 35.4366 32.9776C34.6708 32.9776 33.5614 32.9776 33.3222 32.9776C32.9336 32.9776 32.6175 33.2937 32.6175 33.6823C32.6175 34.0709 32.9336 34.387 33.3222 34.387H36.1409C36.53 34.387 36.8455 34.7025 36.8455 35.0917Z",
    fill: "#51267F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3429 24.228C20.5658 24.228 19.9336 24.8603 19.9336 25.6374C19.9336 26.0266 20.2491 26.3421 20.6383 26.3421H22.0476C22.4368 26.3421 22.7523 26.0266 22.7523 25.6374C22.7523 24.8603 22.1201 24.228 21.3429 24.228Z",
    fill: "#51267F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6842 20.9075C27.6842 20.4063 27.2779 20 26.7766 20H15.9075C15.4063 20 15 20.4063 15 20.9075V31.7767C15 32.2779 15.4063 32.6842 15.9075 32.6842H17.6158C18.1171 32.6842 18.5234 33.0905 18.5234 33.5918V33.7653C18.5234 34.44 19.2334 34.8788 19.8368 34.5771L23.4309 32.78C23.5569 32.717 23.6958 32.6842 23.8367 32.6842H26.7766C27.2779 32.6842 27.6842 32.2779 27.6842 31.7767V20.9075ZM24.1608 29.1608C24.1608 29.55 23.8453 29.8655 23.4561 29.8655C23.0669 29.8655 22.7514 29.55 22.7514 29.1608V28.659C22.7514 28.1578 22.3451 27.7514 21.8439 27.7514H20.8403C20.3391 27.7514 19.9327 28.1578 19.9327 28.659V29.1608C19.9327 29.55 19.6172 29.8655 19.2281 29.8655C18.8389 29.8655 18.5234 29.55 18.5234 29.1608V25.6374C18.5234 24.0832 19.7879 22.8187 21.3421 22.8187C22.8963 22.8187 24.1608 24.0832 24.1608 25.6374V29.1608Z",
    fill: "#51267F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_795_735",
    x: -15,
    y: -10,
    width: 83.959,
    height: 90.8711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_795_735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_795_735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.959,
    height: 22.8711,
    fill: "white",
    transform: "translate(15 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguseChange);
export default __webpack_public_path__ + "static/media/languseChange.d1cb444ecbf99387715f833a066a167c.svg";
export { ForwardRef as ReactComponent };